import { useQuery } from '@tanstack/vue-query'
import { TanStackQueryIds } from '../query-ids'
import { getFavorites } from '~~/src/api/elementals'

export const useGetAllFavoritesQuery = () => {
  return useQuery({
    queryKey: [TanStackQueryIds.FAVORITES],
    queryFn: () => getFavorites(),
  })
}
